<div class="toggle">
  <input
    class="toggle__input"
    type="checkbox"
    [id]="switchId"
    [name]="switchId"
  />
  <label class="toggle__label" [for]="switchId">
    <span class="toggle__track"></span>
  </label>
</div>
